module.exports = __webpack_public_path__ + "static/media/BIMbg@2x.d5dd963e.png";